var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { Icon } from "../../Icon/Icon";
import { FormInput } from "../FormInput/FormInput";
import { Flex } from "../../Flex";
const Suffix = ({ isPasswordVisible, togglePasswordVisiblity, togglePasswordVisibilityText }) => {
    const icon = isPasswordVisible ? "ViewOff" : "View";
    return (React.createElement(Flex, { "aria-label": togglePasswordVisibilityText, cursor: "pointer", onClick: togglePasswordVisiblity, justifyContent: "center" },
        React.createElement(Icon, { "data-testid": isPasswordVisible ? "EyeClosedIcon" : "EyeOpenIcon", src: icon, size: "16px" })));
};
export const FormInputPassword = (_a) => {
    var { name, togglePasswordVisibilityText = "Toogle password visibility" } = _a, rest = __rest(_a, ["name", "togglePasswordVisibilityText"]);
    const [isPasswordVisible, setPasswordVisibility] = useState(false);
    const togglePasswordVisiblity = () => {
        setPasswordVisibility(!isPasswordVisible);
    };
    return (React.createElement(FormInput, Object.assign({}, rest, { "data-testid": `FormInputPassword-${name}`, name: name, inputType: isPasswordVisible ? "text" : "password", suffix: React.createElement(Suffix, { togglePasswordVisiblity: togglePasswordVisiblity, isPasswordVisible: isPasswordVisible, togglePasswordVisibilityText: togglePasswordVisibilityText }) })));
};
